import { Navigate } from "react-router-dom";
import { Route } from "react-router-dom";

/**
 * Map of old WordPress slugs → new slugs.
 * Slugs with a match redirect to the correct new post.
 * Slugs with no match redirect to /news.
 */
const redirectMap: Record<string, string> = {
  // Matched redirects (old slug → new slug)
  "cetasol-australia": "cetasol-australia-blog-post",
  "cetasol-in-singapore": "cetasol-in-singapore-blog-post",
  "cetasol-innovation-virtual-sensor": "innovation-virtual-sensor-blog-post",
  "cetasol-maritime-management-partnership": "maritime-management-partnership-blog-post",
  "cetasol-startup4climate": "cetasol-startup4climate-blog-post",
  "cetasols-innovative-digitalization-project": "cetasols-innovative-digitalization-project-2",
  "data-trends-blogpost": "data-trends-blog-post",
  "ihelm-for-electric-and-hybrid": "ihelm-for-electric-and-hybrid-blog-post",
  "ihelm-in-italy": "ihelm-in-italy-blog-post",
  "ihelm-logbook": "ihelm-logbook-blog-post",
  "installation-of-ihelm-on-vessel-in-denmark": "installation-of-ihelm-on-vessel-in-denmark-blog-post",
  "launch-emission-reporting": "launch-emission-reporting-blog-post",
  "tele2-article": "tele2-article-blog-post",
  "vessel-efficiency-fuel-consumption": "vessel-efficiency-fuel-consumption-blog-post",
  "vessel-optimization": "vessel-optimization-blog-post",
  "vinnova-supports-cetasol-in-taking-ai-platform-to-next-level": "vinnova-supports-cetasol-blog-post",
  "were-finalists-in-the-nordic-startup-awards": "nordic-startup-awards-blog-post",
  "winners-nordicstartupchallenge": "winners-nordic-startup-challenge-blog-post",
  "winner-of-the-stena-line-propeller-prize": "steana-line-propelle-prize-blog-post",
  "erik-thun-press-release": "erik-thun-group-blog-post",
  "optimizing-sustainability-the-story-behind-ihelm": "story-behind-ihelm-platform-blog-post",
  "transparancy-of-data-in-marine-sector": "transparent-data-blog-post",
  "saving-fuel": "save-fuel-at-sea-plog-post",
  "operational-data": "operational-maritime-data",
  "installation-on-cinderella-ll": "installation-with-stromma-blog-post",
};

// Old slugs with no match — redirect to /news
const noMatchSlugs = [
  "2022-exhibits",
  "cetasol-at-donso",
  "cetasol-at-smm",
  "cetasol-exhibition-plan-2023",
  "cetasol-in-new-exciting-partnership",
  "cetasol-mru",
  "exclusive-workshop-on-data-qualification",
  "ihelm-installation-on-an-entire-fleet",
  "ihelm-will-expand",
  "seawork-exhibition-blog",
  "seawork2023",
  "swedish-startup-reduces-marine-carbon-footprint-with-ai",
  "webinar-by-ethan-faghani-at-smf",
];

// Additional direct redirects (path → target)
const directRedirects: Record<string, string> = {
  "/book-helm-demo": "/contact",
  "/sv/bok-helm-demo": "/contact",
  "/ihelm-intelligent-support-system": "/ihelm-intelligent-platform",
  "/investor-insights": "/news",
  "/cetasol-customers": "/about-us",
  "/sv/cetasol-kunder": "/about-us",
  "/customers": "/about-us",
  "/sv/customers": "/about-us",
  "/projects/intelligent-helm": "/ihelm-intelligent-platform",
  "/projects/evaluation-of-electrification": "/ihelm-intelligent-platform",
  "/ferry-program-form": "/contact",
  "/sv/färjeprogramformulär": "/contact",
};

export const wordPressRedirectRoutes = [
  ...Object.entries(redirectMap).map(([oldSlug, newSlug]) => (
    <Route
      key={oldSlug}
      path={`/${oldSlug}`}
      element={<Navigate to={`/${newSlug}`} replace />}
    />
  )),
  ...noMatchSlugs.map((slug) => (
    <Route
      key={slug}
      path={`/${slug}`}
      element={<Navigate to="/news" replace />}
    />
  )),
  ...Object.entries(directRedirects).map(([path, target]) => (
    <Route
      key={path}
      path={path}
      element={<Navigate to={target} replace />}
    />
  )),
  // Catch-all redirects for author/user paths
  <Route key="author-wildcard" path="/author/*" element={<Navigate to="/news" replace />} />,
  <Route key="user-wildcard" path="/user/*" element={<Navigate to="/news" replace />} />,
  <Route key="sv-user-wildcard" path="/sv/användare/*" element={<Navigate to="/news" replace />} />,
];
